import { render, staticRenderFns } from "./huxingpicker.vue?vue&type=template&id=16b4c663&scoped=true&"
import script from "./huxingpicker.vue?vue&type=script&lang=js&"
export * from "./huxingpicker.vue?vue&type=script&lang=js&"
import style0 from "./huxingpicker.vue?vue&type=style&index=0&id=16b4c663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4c663",
  null
  
)

export default component.exports